
        <!-- data table -->
        <div 
        *ngIf="!isMobile"
        matSort 
        (matSortChange)="sortData($event)"
        class="table-div">
            <table class="table table-striped">
                <thead>
                    <tr>
                        
                        <th 
                        scope="col"
                        mat-sort-header="wallet">
                            Territorial Partner
                        </th>

                        <th 
                        *ngIf="currentTab == 'dealer'"
                        scope="col"
                        mat-sort-header="wallet">
                            Dealer
                        </th>

                        <th 
                        *ngIf="currentTab == 'subdealer'"
                        scope="col"
                        mat-sort-header="wallet">
                            Subdealer
                        </th>

                        <th 
                        scope="col"
                        mat-sort-header="seller_username">
                            Seller Username
                        </th>

                        <!-- <th 
                        scope="col"
                        mat-sort-header="product_name">
                            e-Pins Denoms
                        </th> -->
                        
                        <th 
                        scope="col"
                        mat-sort-header="seller_level">
                            Seller Level
                        </th>
                        
                        <th 
                        scope="col"
                        mat-sort-header="sku">
                            SKU
                        </th>
                        
                        <th 
                        scope="col"
                        mat-sort-header="amount_of_transaction">
                            Amount
                        </th>
                        
                        <th 
                        scope="col"
                        mat-sort-header="recipient_mobile">
                            Recipient Mobile No.
                        </th>

                        <th 
                        scope="col"
                        mat-sort-header="account_no">
                            Recipient Acc. No.
                        </th>

                        <th 
                        scope="col"
                        mat-sort-header="date_order_completion">
                            Completion Date & Time
                        </th>
                        
                    </tr>
                </thead>
                <tbody *ngIf="!isLoading && !message">
                    <tr *ngFor="let sellOut of sellOutData; index as i">
                        <td>{{ sellOut.tp ?? 'N/A' }}</td>
                        <td *ngIf="currentTab == 'dealer'">{{ sellOut.dealer ?? 'N/A' }}</td>
                        <td *ngIf="currentTab == 'subdealer'">{{ sellOut.subdealer ?? 'N/A' }}</td>
                        <td>{{ sellOut.seller_username ?? 'N/A' }}</td>
                        <td>{{ sellOut.seller_level ? globalservice.userLevelTransition(sellOut.seller_level) : 'N/A' }}</td>
                        <td>{{ sellOut.sku ?? 'N/A' }}</td>
                        <td>{{ sellOut.amount_of_transaction ? ('₱'+globalservice.numberWithCommas(sellOut.amount_of_transaction)) : 'N/A' }}</td>
                        <td>{{ sellOut.recipient_mobile ?? 'N/A' }}</td>
                        <td>{{ sellOut.account_no ?? 'N/A' }}</td>
                        <td>{{ sellOut.date_order_completion ? globalservice.dateToString(sellOut.date_order_completion) : 'N/A' }}</td>
                        <td>
                            <button 
                                class="view-details-btn"
                                (click)="onClickRow(sellOut)">
                                View
                            </button>
                        </td>
                        <!-- <td>{{ sellOut.product_name }}</td> -->
                        <!-- <td>{{ sellOut.create_date }}</td>
                        <td>{{ sellOut.name }}</td>
                        <td>{{ sellOut.classification }}</td>
                        <td>{{ sellOut.subscriber }}</td> -->
                    </tr>
                </tbody>

                
                <div 
                *ngIf="message && !isLoading" 
                class="m-auto error-message">
                    <span>{{message}}</span>
                </div>

                <div 
                *ngIf="isLoading" class="table-spinner-div">
                    <span class="sr-only"> <div class="spinner-border" role="status"> </div> Loading...</span>
                </div>

            </table>
        </div>

        <div 
        *ngIf="isMobile"
        class="card-list">
            
            <div *ngIf="!isLoading && !message">
                <tr *ngFor="let sellOut of sellOutData; index as i">
                    <div class="items-card">
                        <span><span class="label">Dealer: </span>{{ sellOut.dealer_username }}</span>
                        <span><span class="label">Territorial Partner: </span>{{ sellOut.tp_username }}</span>
                        <span><span class="label">e-Pins Denoms: </span>{{ sellOut.product_name }}</span>
                        <span><span class="label">Amount: </span>₱{{ globalservice.numberWithCommas(sellOut.amount) }}</span>
                        <span><span class="label">Date: </span>{{ sellOut.create_date }}</span>
                        <span><span class="label">Name: </span>{{ sellOut.name }}</span>
                        <span><span class="label">Classification: </span>{{ sellOut.classification }}</span>
                        <span><span class="label">Subscriber: </span>{{ sellOut.subscriber }}</span>
                    </div>
                </tr>
            </div>
            
            <div *ngIf="message && !isLoading" class="m-auto error-message"><span>{{message}}</span></div>

            <div *ngIf="isLoading" class="table-spinner-div">
                <span class="sr-only"> <div class="spinner-border" role="status"> </div> Loading...</span>
            </div>

        </div>

        <app-sell-out-details/>